import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=44b2ddb9&scoped=true"
import script from "./orderDetail.vue?vue&type=script&lang=js"
export * from "./orderDetail.vue?vue&type=script&lang=js"
import style0 from "./orderDetail.vue?vue&type=style&index=0&id=44b2ddb9&prod&lang=css"
import style1 from "./orderDetail.vue?vue&type=style&index=1&id=44b2ddb9&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b2ddb9",
  null
  
)

export default component.exports